import { computed } from "@vue/composition-api";
import ui from "@/store/modules/ui";
import annotations from "@/store/modules/annotations";
import useMouseSvg from "@/composables/useMouseSvg";
import {
  mdiToilet,
  mdiHotTub,
  mdiChefHat,
  mdiHandWater,
  mdiWaterPump,
  mdiWashingMachine,
  mdiFire
} from "@mdi/js";

export default function useMisc() {
  //
  // Store mappings
  // -----------------------------------------------------------------
  //
  const selectedMiscType = computed(() => ui.selectedMiscType);
  const misc = computed(() => annotations.getMisc);
  //
  // Misc Types
  // -----------------------------------------------------------------
  //
  const types = [
    {
      value: "toilet",
      name: "Toilet",
      icon: mdiToilet
    },
    {
      value: "bathtub",
      name: "Bathtub",
      icon: mdiHotTub
    },
    {
      value: "kitchen",
      name: "Kitchen",
      icon: mdiChefHat
    },
    {
      value: "washingMachine",
      name: "Washing Machine",
      icon: mdiWashingMachine
    },
    {
      value: "bathroomSink",
      name: "Bathroom Sink",
      icon: mdiHandWater
    },
    {
      value: "gasStove",
      name: "Gas Stove",
      icon: mdiFire
    },
    {
      value: "kitchenSink",
      name: "Kitchen Sink",
      icon: mdiWaterPump
    }
  ];
  //
  // Tools
  // -----------------------------------------------------------------
  //
  // Place new misc
  const place = e => {
    // if not left mouse button, return
    if (e.button !== 0) return;
    // if selected type is empty, return
    if (selectedMiscType.value === "") return;
    const { pos: mousePosSvg } = useMouseSvg(e);
    const newPt = mousePosSvg(e);
    const newMisc = {
      name: selectedMiscType.value,
      pos: {
        cx: newPt.x,
        cy: newPt.y
      }
    };
    annotations.addMisc(newMisc);
  };
  // Move existing misc
  const move = (e, i) => {
    // return if not pressed by the left(main) mouse button
    if (e.button !== 0) return;
    // get svg element (the canvas)
    const elem = e.currentTarget.closest("svg");
    const { pos: mousePosSvg } = useMouseSvg(e);

    let moving = true;
    let newPt;

    const updateFn = () => {
      if (moving) requestAnimationFrame(updateFn);

      annotations.set({ path: `misc[${i}].pos.cx`, value: newPt.x });
      annotations.set({ path: `misc[${i}].pos.cy`, value: newPt.y });
    };

    const moveFn = e => {
      newPt = mousePosSvg(e);
    };

    const stopFn = () => {
      moving = false;
      elem.removeEventListener("mousemove", moveFn);
      elem.removeEventListener("mouseup", stopFn);
    };

    requestAnimationFrame(updateFn);
    moveFn(e);

    elem.addEventListener("mousemove", moveFn);
    elem.addEventListener("mouseup", stopFn);
  };

  const remove = (e, i) => {
    // if not left mouse button, return
    if (e.button !== 0) return;

    annotations.removeMisc(i);
  };

  return {
    misc,
    place,
    move,
    remove,
    types
  };
}
